import { ajaxGet, ajaxPost, httpActions } from '@figure/frontlib-onboarding-redux';

const { baseUrl } = httpActions;

export const GET_APPLICATION_DISCLOSURES = 'GET_APPLICATION_DISCLOSURES';
export const DOWNLOAD_DOCUMENT = 'DOWNLOAD_DOCUMENT';
export const ESIGN_DISCLOSURE = 'ESIGN_DISCLOSURE';

const SECURE = `${baseUrl()}/service-application-pl/secure/api/v1`;
const ELECTRONIC_DOCUMENT_CONTEXT = '/service-edocs-pl/secure/api/v1';

export const getApplicationDisclosures = (personalLoanUuid, disclosureListUuid) => async (dispatch) =>
  ajaxGet(GET_APPLICATION_DISCLOSURES, dispatch, `${SECURE}/application/${personalLoanUuid}/disclosures/${disclosureListUuid}`);

export const downloadDocument = (personalLoanUuid, disclosurelistUuid, documentUuid) => async (dispatch) =>
  ajaxGet(
    DOWNLOAD_DOCUMENT,
    dispatch,
    `${SECURE}/application/${personalLoanUuid}/disclosures/${disclosurelistUuid}/documents/${documentUuid}/downloads`,
    { responseType: 'arraybuffer' }
  );

export const esignDisclosure = (data) => async (dispatch) =>
  ajaxPost(ESIGN_DISCLOSURE, dispatch, `${baseUrl()}${ELECTRONIC_DOCUMENT_CONTEXT}/esignAgreement`, data);
